export default __webpack_public_path__ + "static/media/aar.4940393c.png";